(function () {

    "use strict";

    function routingConfiguration() {

    }

    routingConfiguration.$inject = [];

    angular.module("solpheo")
        .config(routingConfiguration); 

}());